import { render, staticRenderFns } from "./CreditLimitPopup.vue?vue&type=template&id=3462e1fe&scoped=true"
import script from "./CreditLimitPopup.vue?vue&type=script&lang=js"
export * from "./CreditLimitPopup.vue?vue&type=script&lang=js"
import style0 from "./CreditLimitPopup.vue?vue&type=style&index=0&id=3462e1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462e1fe",
  null
  
)

export default component.exports